import { t } from '@lingui/core/macro';
import { QueryField } from 'shared/domains/forms';
export function TableToolbar(props) {
    const { onSearch, loading, value } = props;
    const handleSearch = (newValue) => {
        onSearch(newValue);
    };
    const handleClear = () => {
        onSearch('');
    };
    return (<QueryField placeholder={t({ message: 'Search', comment: 'search placeholder for tableToolbar' })} loading={loading} onChange={(e) => {
            handleSearch(e.target.value);
        }} onClear={handleClear} value={value}/>);
}
